/**
 * DateTime formatting (SPEC-48 Fix G).
 *
 * Unifies 6 divergent copies with 4 different signatures across the web
 * surfaces into a single shared helper.
 *
 * RENDERING CONTRACT (SPEC-48 §1G / §2G):
 *   - Falsy (`null`, `undefined`, `""`) → `"—"` (em-dash)
 *   - `string` input → parsed and rendered in local-tz with year, short month,
 *     day, numeric hour, 2-digit minute:
 *       `new Date(iso).toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })`
 *     If the parsed Date is invalid (NaN timestamp) → returns `"Invalid Date"`.
 *   - `Date` input → `iso.toISOString()` (UTC). Callers pre-format if they
 *     want local-tz rendering from a Date object.
 */
export function formatDateTime(
  iso: string | Date | null | undefined,
): string {
  if (!iso) return "—";

  if (iso instanceof Date) {
    if (isNaN(iso.getTime())) return "Invalid Date";
    return iso.toISOString();
  }

  const d = new Date(iso);
  if (isNaN(d.getTime())) return "Invalid Date";

  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
